import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import { StandardTextListItemElement } from "@easy-email-pro-core/typings";
import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: StandardTextListItemElement = {
  type: StandardType.STANDARD_TEXT_LIST_ITEM,
  data: {},
  attributes: {},
  children: [],
};

export const StandardTextListItem = createBlock<StandardTextListItemElement>({
  get name() {
    return t("Text list");
  },
  defaultData,
  type: StandardType.STANDARD_TEXT_LIST_ITEM,
  create: (payload) => {
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TEXT_LIST_ITEM,
  render(params) {
    return (
      <BasicBlock
        tag="li"
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {} as any,
          },
        }}
      />
    );
  },
});
